import { enqueueSnackbar } from "notistack";
import { shareFlightBookingPDF } from "../../controllers/Flight/shareFlightBookingPDF";
import getBooking from "../../controllers/booking/getBooking";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default function useFlightBooking() {
    
      async function sendPDF({pdf, datas, booking}) {
        const orderData = booking?.flightBooking?.at(0);
    
        const bookingId = booking?.bookingId;
        const date = booking?.createdDate;
        const departure = orderData?.flights[0]?.departureLocation;
        const arrival = orderData?.flights[0]?.arrivalLocation;
    
        const formData = new FormData();
    
        datas?.map((data) => formData?.append("to", data.email));
        formData.append("subject", "Flight Booking Details");
        formData.append(
          "body",
          "Booking details of " + departure + " to " + arrival
        );
        formData.append("pdf", pdf, bookingId + "--" + date + ".pdf");
    
        enqueueSnackbar("Sending... (This might take a while if the pdf is large)");
        const res = await shareFlightBookingPDF(formData);
        if (res.return) {
          enqueueSnackbar(res?.msg, { variant: "success" });
        } else enqueueSnackbar(res?.msg, { variant: "error" });
      }

      async function handlePDFExport({id,callback,returnBolb}) {
        const res = await getBooking(id);
        callback && callback(res);
        await new Promise((resolve) => setTimeout(() => resolve(), 1000));
        const order = res?.data
    
        const component = document.getElementById("flightDoc");
    
        const desiredWidth = 795; // Set your desired width here
    
        const scaleFactor = desiredWidth / component.offsetWidth;
    
        const desiredHeight = component.offsetHeight * scaleFactor;
    
        // component.style.width = `${desiredWidth}px`;
        // component.style.height = `${desiredHeight}px`;
    
        const segments = Array.from(
        { length: Math.ceil(component?.offsetHeight / desiredHeight) + 1 },
        (_, index) => index * desiredHeight
        );
        console.log(segments,component?.offsetHeight,desiredHeight)
        const pdf = new jsPDF();
    
        function captureSegmentScreenshot(index) {
        if (index >= segments.length) {
            if (returnBolb) returnBolb(pdf.output("blob"),res?.data?.booking);
            else pdf.save(order?.booking?.bookingId || order?.booking?.ticketNo + ".pdf");
    
            component.style.width = "auto";
            component.style.height = "auto";
    
            return;
        }
    
        if (index) pdf.addPage();
    
        setTimeout(
            () =>
            html2canvas(component, { useCORS: true, allowTaint: false }).then((canvas) => {
                const imgData = canvas.toDataURL("image/png");
    
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    
                const xPos =
                (pdfWidth - canvas.width * (pdfHeight / canvas.height)) / 2;
                const yPos = index * (desiredWidth - 500);
    
                pdf.addImage(
                imgData,
                "PNG",
                xPos,
                -yPos,
                canvas.width * (pdfHeight / canvas.height),
                pdfHeight
                );
    
                captureSegmentScreenshot(index + 1);
            }),
            10
        );
        }
    
        captureSegmentScreenshot(0);

        return res
      }
      
  return {
    sendPDF,
    handlePDFExport,
  }
}
